module.exports = __webpack_public_path__ + "img/login-olsera-icon.c2cec884.png";